import { render, staticRenderFns } from "./FeaturedReservations.vue?vue&type=template&id=12309215&"
import script from "./FeaturedReservations.vue?vue&type=script&lang=js&"
export * from "./FeaturedReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports